import { api } from "@/lib/api";

export const MAP_PARTY_COLORS = {
  TVK: "#f2b705",
  DMK: "#d62828",
  AIADMK: "#1f9d55",
  INC: "#2f6fdb",
  PMK: "#f4791f",
  VCK: "#0ea5e9",
  BJP: "#fb923c",
  CPI: "#9d174d",
  "CPI-M": "#7f1d1d",
  IUML: "#065f46",
  AMMK: "#14b8a6",
  DMDK: "#7c3aed",
};
export const NO_DATA_COLOR = "#d6d3e6";

const PARTY_TA = {
  TVK: "தவெக", DMK: "திமுக", AIADMK: "அதிமுக", INC: "காங்கிரஸ்", PMK: "பாமக", VCK: "விசிக",
  BJP: "பாஜக", CPI: "இ.கம்யூ.", "CPI-M": "மா.கம்யூ.", IUML: "இ.யூ.மு.லீ", AMMK: "அமமுக", DMDK: "தேமுதிக",
};
export const partyLabel = (short, lang) => (lang === "ta" && PARTY_TA[short]) || short;

export const OUTCOME_COLORS = {
  flipped: "#e4572e",
  same_party_new: "#f2b705",
  same_mla: "#2a9d8f",
  same_mla_switched: "#7c3aed",
  not_compared: NO_DATA_COLOR,
};
export const OUTCOME_ORDER = ["flipped", "same_party_new", "same_mla", "same_mla_switched", "not_compared"];

export function seatColor(seat, mode) {
  if (mode === "change") return OUTCOME_COLORS[seat.outcome_key] || NO_DATA_COLOR;
  return MAP_PARTY_COLORS[seat.y2026?.party_short] || NO_DATA_COLOR;
}

export function formatRupees(n, t) {
  if (n === null || n === undefined) return "—";
  const abs = Math.abs(n);
  const sign = n < 0 ? "−" : "";
  if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toLocaleString("en-IN", { maximumFractionDigits: 2 })} ${t("cr")}`;
  if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toLocaleString("en-IN", { maximumFractionDigits: 2 })} ${t("lakh")}`;
  return `${sign}₹${abs.toLocaleString("en-IN")}`;
}

export function formatCr(n) {
  if (n === null || n === undefined) return "—";
  return `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}

// Picks the Tamil text for a field when available, else English
export function pick(obj, field, lang) {
  if (lang === "ta" && obj?.ta?.[field]) return obj.ta[field];
  return obj?.[field];
}

const cache = {};
function cached(key, loader) {
  if (!cache[key]) cache[key] = loader().catch((e) => { delete cache[key]; throw e; });
  return cache[key];
}

export const fetchSeats = () => cached("seats", () => api.get("/insights/seats").then((r) => r.data.items));
export const fetchFunFacts = () => cached("facts", () => api.get("/insights/funfacts").then((r) => r.data));
export const fetchSchemes = () => cached("schemes", () => api.get("/insights/schemes").then((r) => r.data));
export const fetchGeo = () =>
  cached("geo", () => fetch(`${process.env.PUBLIC_URL || ""}/tn-constituencies.geojson`).then((r) => r.json()));
export async function fetchSeat(constituency) {
  const { data } = await api.get("/insights/seat", { params: { constituency } });
  return data;
}
